import jobsFilters from '../modules/jobs-filters';

export default {
  init() {
    jobsFilters();
  },
  finalize() {},
};
